/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    NumberField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    Datagrid,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { EditToolbar } from '../layout/EditToolbar';
import { NumberInput, TextInput } from '../lib/wrappers/Inputs';

export const CourseLevelLabels = {
    pageTitle: 'Course Levels',
    singleLabel: 'Course Level',
    Title: 'Code',
    maxcredits: 'Max Credits',
};

export const CourseLevelList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} filters={<BaseFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="maxcredits" />
                    <TextField source="description" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const CourseLevelEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput source="description" />
                    <NumberInput source="maxcredits" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const CourseLevelCreate = (props) => {
    const { canEditStaticData } = useAzureADGroups();

    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Create {...props} redirect="edit">
                <SimpleForm>
                    <TextInput source="id" disabled />
                    <TextInput source="description" />
                    <NumberInput source="maxcredits" />
                </SimpleForm>
            </Create>
        </ReadOnlyContext.Provider>
    );
};

export const CourseLevelShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="description" />
            <NumberField source="maxcredits" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
